<!-- ./FAQs -->
<section class="section bg-light">
  <div class="container">
    <div class="row gap-y">
      <div class="col-lg-8 b-md-l order-lg-2">
        <h3 class="light">Common Questions</h3>
        <hr class="mb-4" />

        <dc-faqs-accordion></dc-faqs-accordion>
      </div>

      <div class="col-lg-4">
        <dc-faqs-sidebar></dc-faqs-sidebar>
      </div>
    </div>
  </div>
</section>
